import React, { useState } from 'react'

import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { convertBytes } from 'utils/FileUtils'
import { FILE_MAX_SIZE_DEFAULT } from 'constants/filesMaxSize'

const FileUploaderButton = (props) => {
  const { className, acceptedTypes, maxSize, disabled, value, onChange } = props

  const [file, setFile] = useState(value || null)
  const [errorMsg, setErrorMsg] = useState('')
  const maxFileSize = (maxSize || FILE_MAX_SIZE_DEFAULT) / 1e+6

  const handleChooseFile = () => {
    if (errorMsg) setErrorMsg('')
    if (file) setFile(null)

    const input = document.createElement('input')
    input.type = 'file'
    if (acceptedTypes) input.accept = acceptedTypes
    input.onchange = () => {
      const file = Array.from(input.files)[0]
      if (file.size <= (maxSize || FILE_MAX_SIZE_DEFAULT)) {
        setFile(file)
        if (typeof onChange === 'function') onChange(file)
      } else {
        setErrorMsg(lang('dashboard_max-file-size-mb', { mb: maxFileSize }))
      }
    }
    input.click()
  }

  const fileName = file?.resource || file?.name

  return (
    <>
      {
        !file?.consoleId ? (
          <button
            className={`file-selector-button ${disabled ? 'file-selector-button--disabled' : '' } ${className || ''}`}
            disabled={disabled}
            onClick={handleChooseFile}
          >
            <figure className='file-selector-button__icon'>
              <img src={getStaticImage('/icons/icon-upload-dark.svg')} alt='Upload' />
            </figure>
            {lang('dashboard_upload-file')}
          </button>
        ) : null
      }

      {errorMsg ? (
        <p className='file-selector-button__text-error'>{errorMsg}</p>
      ) : (
        <>
          {fileName ? <p className='file-selector-button__name'>{fileName}</p> : null}
          {file?.size ? <span className='file-selector-button__size'>({convertBytes(file.size)})</span> : null}
        </>
      )}
    </>
  )
}

export default FileUploaderButton
